<template>
    <div class="flex-col page">
        <div class="flex-col group_3">
            <div class="block" v-for="(item, index) in couponList"
                :style="'color:' + item.fontColor + ';background-image:url(' + mixin_imgs[getOSSImg(item.backGroundImg)] + ')'">
                <p class="title">{{ item.equitieName }}</p>
                <div class="justify-between couponItem" :class="couponItem.redeemCodeState == 2 ? '' : 'disabled'"
                    v-if="item.useType != 3" v-for="couponItem in item.redeemCoupList">
                    <div>卷码 {{ couponItem.redeemCouponCode }}</div>
                    <span @click="copy(couponItem)"
                        :style="'color:' + (couponItem.redeemCodeState == 2 ? '#666' : '#ccc') + ';margin-right:' + (couponItem.redeemCodeState == 2 ? '5px' : '')">
                        {{ stateMap[couponItem.redeemCodeState] }}
                    </span>
                </div>
                <button class="couponButton" @click="jump(item)"
                    :style="'background-color:' + item.buttonColor">{{ item.buttonName }}</button>
                <div :ref="'ref'" class="rules" :class="item.showDrop ? 'h-3em' : 'h-auto'">
                    {{ item.settingExplain }}
                </div>
                <div class="justify-center" @click="showAndHide" v-if="item.showDrop">
                    <div v-if="!item.isShowAll" class="flex-row">
                        <span class="text_14" @click="showDropHandle(item, index)">展开</span>
                        <img src="https://imgpub1.shouqiev.com/gofunplatform/files/20220816/EebwiItORh.png"
                            class="image_4" />
                    </div>
                    <div v-else class="flex-row">
                        <span class="text_14" @click="hideDropHandle(item, index)">收起</span>
                        <img src="https://imgpub1.shouqiev.com/gofunplatform/files/20220816/QJwBSNIoUU.png"
                            class="image_4" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getMyOrderEquitieList } from "../api"
import { getImgMixin } from '../getImg_mixin'
export default {
    components: {},
    data() {
        return {
            couponList: [],
            stateMap: {
                1: "已兑换",
                2: "复制",
                3: "已过期"
            },
        };
    },
    mixins: [getImgMixin],
    methods: {
        showDropHandle(item, index) {
            console.log("showDropHandle", item)
            item.isShowAll = true;
            this.$refs.ref[index].style.height = item.height + 'px'
        },
        hideDropHandle(item, index) {
            console.log("hideDropHandle")
            item.isShowAll = false;
            this.$refs.ref[index].style.height = '3em'
        },
        copy(item) {
            if (item.redeemCodeState == 1) { // 已使用
                return;
            }

            let copyInput = document.createElement('input');//创建input元素
            document.body.appendChild(copyInput);//向页面底部追加输入框
            copyInput.setAttribute('value', item.redeemCouponCode);//添加属性，将url赋值给input元素的value属性
            copyInput.select();//选择input元素
            document.execCommand("Copy");//执行复制命令
            this.$toast("已复制！");
            copyInput.remove();//删除动态创建的节点
        },
        showAndHide() {

        },
        jump(item) {
            if (item.useType == 2) { // useType==2的时候 跳转gofun平台兑换验证码页面
                console.log({
                    orderId: this.$route.params.orderId
                })
                this.$router.push({
                    path: `/salePassat/exchangeCouponCode`,
                    query: {
                        orderId: this.$route.params.orderId
                    }
                })

                return false
            }
            location.href = item.jumpUrl
        }
    },
    created() {
        // 后台系统 通过url传参数进行样式预览
        if (this.$route.query.crmtest == 'true') {
            const params = {
                fontColor: this.$route.query.fontColor,
                backGroundImg: decodeURIComponent(this.$route.query.backGroundImg),
                equitieName: decodeURI(this.$route.query.equitieName),
                useType: this.$route.query.useType,
                buttonColor: this.$route.query.buttonColor,
                buttonName: decodeURI(this.$route.query.buttonName),
                settingExplain: this.$route.query.settingExplain,
            }
            if (this.$route.query.useType != 3) {
                params.redeemCoupList = [{
                    redeemCouponCode: "测试数据",
                    redeemCodeState: 1
                }, {
                    redeemCouponCode: "测试数据",
                    redeemCodeState: 2
                }]
            }
            this.couponList.push(params)
            this.$nextTick(() => {
                console.log(this.$refs.ref)
                this.couponList = this.couponList.map((item, index) => {
                    console.log(this.$refs.ref[index].offsetHeight)
                    return {
                        ...item,
                        height: this.$refs.ref[index].offsetHeight,
                        showDrop: this.$refs.ref[index].offsetHeight > 60 ? true : false,
                        isShowAll: false,
                    }
                })
            })
        } else {
            getMyOrderEquitieList({ orderId: this.$route.params.orderId }).then(res => {
                this.couponList = res.result
                this.$nextTick(() => {
                    console.log(this.$refs.ref)
                    this.couponList = this.couponList.map((item, index) => {
                        console.log(this.$refs.ref[index].offsetHeight)
                        return {
                            ...item,
                            height: this.$refs.ref[index].offsetHeight,
                            showDrop: this.$refs.ref[index].offsetHeight > 60 ? true : false,
                            isShowAll: false,
                        }
                    })
                })
            })
        }
    },
};
</script>

<style scoped lang="scss">
@import '../common.css';
.page {
    padding-top: 0.027rem;
    background-color: #f5f5f5;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;

    .group_3 {
        padding: 0.21rem 0.21rem;
        overflow-y: auto;

        .block {
            padding: 0.32rem 0.32rem;
            border-radius: 0.21rem;
            background-position: 0% 0%;
            background-size: cover;
            background-repeat: no-repeat;
            margin-bottom: 16px;

            p.title {
                margin-bottom: 32px;
                align-self: flex-start;
                font-size: 0.43rem;
                font-family: 'PingFang SC';
                font-weight: 500;
                line-height: 0.59rem;
            }

            .couponItem {
                margin-bottom: 32px;
                padding: 0 24px;
                width: 670px;
                height: 88px;
                line-height: 88px;
                ;
                background-image: url('https://imgpub1.shouqiev.com/gofunplatform/files/20220816/BnveNkWLyb.png');
                background-position: 0% 0%;
                background-size: 100% 100%;
                background-repeat: no-repeat;
                font-family: PingFangSC-Regular;
                font-size: 28px;
                color: #333;
                letter-spacing: 0;
                text-align: center;
                font-weight: 400;
            }

            .couponItem.disabled {
                color: #666666;
            }

            .couponButton {
                width: 670px;
                height: 88px;
                line-height: 88px;
                border-radius: 48px;
                font-size: 32px;
                font-weight: 500;
                color: white;
            }

            .rules {
                transition: all ease 0.3s;
                font-size: 24px;
                margin-top: 48px;
                margin-bottom: 16px;
                line-height: 30px;
                overflow: hidden;
            }
        }

        .image_4 {
            margin-left: 10px;
            width: 0.43rem;
            height: 0.43rem;
        }
    }
}

.h-auto {
    height: auto;
}

.h-3em {
    height: 3em;
}
</style>



// WEBPACK FOOTER //
// getCouponCode.vue?7bc6bbb9